// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/logo.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/hide-resize.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/burger.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup_layer{
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-color: #0009;
  display: flex;
  justify-content: center;
  align-items: center;
}

.popup_layer--hidden{
  display: none;
}


.dashboard{
  display: flex;
  height: 100%;
}

.dashboard_right{
  width: 100%;
}

.dashboard_left{
  display: flex;
  flex-direction: column;
  width: 358px;
  padding: 24px;
  gap: 21px;
  flex-shrink: 0;

  /*collapse*/
  position: absolute;
  left: 0;
  transition-duration: 400ms;

  height: 100%;
}

.dashboard_left_header{
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 13.5px 0px;
  padding-top: 0px;
}

.dashboard_left_logo{
  width: 64px;
  height: 64px;
  border-radius: 100%;
  /*background-color: #0009;*/

  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  flex-shrink: 0;
}

.dashboard_left_path{
  width:58%;
}

.dashboard_left_device{
  width: 200px;
  font-style: normal;
  font-weight: 400;
  font-size: calc(24px * var(--fontScaler));
  line-height: 32px;
}

.dashboard_left_screen{
  font-weight: 400;
  font-size: calc(16px * var(--fontScaler));
  line-height: 24px;
  color: #8E9ABB;
}

.dashboard_left_hide_wrap{
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.dashboard_left_hide{
  width: 28px;
  height: 28px;

  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  flex-shrink: 0;
}

.dashboard_clients{
  display: flex;
  flex-direction: column;
  gap: 21px;
  overflow: hidden;
  height: 100%;
}

.dashboard_tabButtons{
  display: flex;
  justify-content: space-between;
  background-color: #ccc;
  padding: 2px;
  background: #F3F6FF;
  border-radius: 8px;
}

.dashboard_tabButton{
  width: 100%;
  background-color: #0000;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: calc(14px * var(--fontScaler));
} 

.dashboard_tabButton_active{
  background-color: #fff;
  border: 0.5px solid #E2E9FC;
  box-shadow: 0px 3px 8px rgba(209, 215, 234, 0.12), 0px 3px 1px rgba(209, 215, 234, 0.04);
}

.dashboard_tabContents{
  overflow: auto;
  height: 100%;
}

.dashboard_tabContent{

}

.dashboard_tabContent_clients{
  padding: 10px 0px;
}

.dashboard_tabContent_schedule{

}

.dashboard_left_collapser{
  position: relative;
  display: flex;
  transition-duration: 400ms;
  width: 358px; /*348 with scroll*/
  flex-shrink: 0;
  overflow: hidden;
}

.dashboard_left_collapser--collapsed .dashboard_left{
  left: -358px;
}

.dashboard_left_collapser--collapsed{
  width: 60px;
}

.dashboard_left_collapser_holder{
  position: absolute;
  left: 358px;
  overflow: hidden;
  transition-duration: 400ms;
  padding: 24px 10px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  width: 60px;
}

.dashboard_left_collapser_button{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  width: 32px;
  height: 32px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}

.dashboard_left_collapser--collapsed .dashboard_left_collapser_holder{
  left: 0;
  overflow: visible;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboardPage/DashboardPage.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,MAAM;EACN,OAAO;EACP,uBAAuB;EACvB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;;AAGA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,SAAS;EACT,cAAc;;EAEd,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,0BAA0B;;EAE1B,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;;EAE3B,yDAA8C;EAC9C,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,yCAAyC;EACzC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;EACzC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,yDAAqD;EACrD,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,wFAAwF;AAC1F;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;;AAEA;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;AAEA;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,0BAA0B;EAC1B,YAAY,EAAE,kBAAkB;EAChC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,yDAAgD;EAChD,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,4BAA4B;EAC5B,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,iBAAiB;AACnB","sourcesContent":[".popup_layer{\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 0;\n  left: 0;\n  background-color: #0009;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.popup_layer--hidden{\n  display: none;\n}\n\n\n.dashboard{\n  display: flex;\n  height: 100%;\n}\n\n.dashboard_right{\n  width: 100%;\n}\n\n.dashboard_left{\n  display: flex;\n  flex-direction: column;\n  width: 358px;\n  padding: 24px;\n  gap: 21px;\n  flex-shrink: 0;\n\n  /*collapse*/\n  position: absolute;\n  left: 0;\n  transition-duration: 400ms;\n\n  height: 100%;\n}\n\n.dashboard_left_header{\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 13.5px 0px;\n  padding-top: 0px;\n}\n\n.dashboard_left_logo{\n  width: 64px;\n  height: 64px;\n  border-radius: 100%;\n  /*background-color: #0009;*/\n\n  background-image: url('../../assets/logo.svg');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  flex-shrink: 0;\n}\n\n.dashboard_left_path{\n  width:58%;\n}\n\n.dashboard_left_device{\n  width: 200px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: calc(24px * var(--fontScaler));\n  line-height: 32px;\n}\n\n.dashboard_left_screen{\n  font-weight: 400;\n  font-size: calc(16px * var(--fontScaler));\n  line-height: 24px;\n  color: #8E9ABB;\n}\n\n.dashboard_left_hide_wrap{\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.dashboard_left_hide{\n  width: 28px;\n  height: 28px;\n\n  background-image: url('../../assets/hide-resize.svg');\n  background-size: contain;\n  background-position: center;\n  background-repeat: no-repeat;\n  flex-shrink: 0;\n}\n\n.dashboard_clients{\n  display: flex;\n  flex-direction: column;\n  gap: 21px;\n  overflow: hidden;\n  height: 100%;\n}\n\n.dashboard_tabButtons{\n  display: flex;\n  justify-content: space-between;\n  background-color: #ccc;\n  padding: 2px;\n  background: #F3F6FF;\n  border-radius: 8px;\n}\n\n.dashboard_tabButton{\n  width: 100%;\n  background-color: #0000;\n  height: 28px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: calc(14px * var(--fontScaler));\n} \n\n.dashboard_tabButton_active{\n  background-color: #fff;\n  border: 0.5px solid #E2E9FC;\n  box-shadow: 0px 3px 8px rgba(209, 215, 234, 0.12), 0px 3px 1px rgba(209, 215, 234, 0.04);\n}\n\n.dashboard_tabContents{\n  overflow: auto;\n  height: 100%;\n}\n\n.dashboard_tabContent{\n\n}\n\n.dashboard_tabContent_clients{\n  padding: 10px 0px;\n}\n\n.dashboard_tabContent_schedule{\n\n}\n\n.dashboard_left_collapser{\n  position: relative;\n  display: flex;\n  transition-duration: 400ms;\n  width: 358px; /*348 with scroll*/\n  flex-shrink: 0;\n  overflow: hidden;\n}\n\n.dashboard_left_collapser--collapsed .dashboard_left{\n  left: -358px;\n}\n\n.dashboard_left_collapser--collapsed{\n  width: 60px;\n}\n\n.dashboard_left_collapser_holder{\n  position: absolute;\n  left: 358px;\n  overflow: hidden;\n  transition-duration: 400ms;\n  padding: 24px 10px;\n  display: flex;\n  justify-content: center;\n  align-items: flex-start;\n  width: 100%;\n  width: 60px;\n}\n\n.dashboard_left_collapser_button{\n  background-image: url(\"../../assets/burger.png\");\n  width: 32px;\n  height: 32px;\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n\n.dashboard_left_collapser--collapsed .dashboard_left_collapser_holder{\n  left: 0;\n  overflow: visible;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
